var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('z-button',_vm._b({attrs:{"icon":_vm.btnIcon,"label":_vm.btnLabel,"disabled":_vm.disabled},on:{"click":_vm.copyContent}},'z-button',_vm.zButtonBindings,false))
}
var staticRenderFns = []

export { render, staticRenderFns }